module.exports = __webpack_public_path__ + "img/index_smzhou.75f2eb8f.png";